// components/ui/Loader/index.tsx
// Re-export loader gốc (animation/load) + thêm wrapper

import OriginalLoader from '../../../animation/load'

interface LoaderProps {
  text?: string
}

const Loader = ({ text = 'Đang tải...' }: LoaderProps) => {
  return (
    <div className="loader-container">
      <OriginalLoader />
      {text && <p className="loader-text">{text}</p>}
    </div>
  )
}

export default Loader
